import React from 'react';
import {
  CContainer,
  CListGroup,
  CListGroupItem,
  CCard,
  CCardBody,
  CCardText,
} from '@coreui/react-pro';
import {
  Map,
  useMap,
  MapControl,
  ControlPosition,
} from '@vis.gl/react-google-maps';
import MapLoadingSpinner from '../shared/MapLoadingSpinner';
import NutrientRemovalMarker from './NutrientRemovalMarker';
import MyFieldsAgvanceFieldBoundary from './MyFieldsAgvanceFieldBoundary';
import {
  fetchFarmFieldsWithNutrientRemoval,
  userSelectedFarmFieldWithNutrientRemoval,
} from './mapping-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const NutrientRemoval = () => {

  const dispatch = useDispatch();

  const map = useMap();

  const {
    sidebarVisible,
    sidebarUnfoldable,
  } = useSelector(state => state.userSettings);

  const {
    fetchingFarmFieldsWithNutrientRemoval,
    farmFieldsWithNutrientRemoval,
    selectedFarmFieldWithNutrientRemoval,
  } = useSelector(state => state.mapping);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    dispatch(fetchFarmFieldsWithNutrientRemoval());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  React.useEffect(() => {
    if (selectedFarmFieldWithNutrientRemoval !== null && map !== null) {
      zoomToLocation(selectedFarmFieldWithNutrientRemoval.Latitude, selectedFarmFieldWithNutrientRemoval.Longitude);
    }
  }, [selectedFarmFieldWithNutrientRemoval, map]); // eslint-disable-line react-hooks/exhaustive-deps

  const zoomToLocation = (latitude, longitude) => {
    map.panTo({
      lat: latitude,
      lng: longitude,
    });
    if (map.zoom >= 16) {
      return;
    }
    else {
      var zoomStep = map.zoom;
      const interval = setInterval(() => {
        if (zoomStep === 16) {
          clearInterval(interval);
        }
        map.setZoom(zoomStep++);
      }, 200);
    }
  }

  const height = windowHeight - 64;

  var width = windowWidth;

  if (sidebarUnfoldable === true && sidebarVisible === true) {
    width -= 64;
  }
  else if (sidebarUnfoldable === false && sidebarVisible === true) {
    width -= 256;
  }

  return (
    <div style={{flexDirection: 'row', display: 'flex',}}>
      <div style={{
        width: 300,
        height: height,
        overflowY: 'auto', 
      }}>
        <CContainer fluid>
          <CCard>
            <CCardBody>
              <CCardText style={{marginBottom: 'unset', fontStyle: 'italic',}}>
                Potash Removal Formulas:
              </CCardText>
              <CCardText style={{marginBottom: 'unset',}}>
                Corn: (Yield * 0.24) / 0.6
              </CCardText>
              <CCardText>
                Beans: (Yield * 1.17) / 0.6
              </CCardText>
              <CCardText style={{marginBottom: 'unset', fontStyle: 'italic',}}>
                MAP Removal Formulas:
              </CCardText>
              <CCardText style={{marginBottom: 'unset',}}>
                Corn: (Yield * 0.37) / 0.52
              </CCardText>
              <CCardText>
                Beans: (Yield * 0.75) / 0.52
              </CCardText>
            </CCardBody>
            <CCardBody style={{paddingTop: 'unset',}}>
              <CCardText>
                Click on a Field Name below to zoom to the field and see its data.
              </CCardText>
              <CListGroup>
                {
                  farmFieldsWithNutrientRemoval.map((field, index) => {
                    return (
                      <CListGroupItem 
                        key={field.FieldId + index}
                        active={selectedFarmFieldWithNutrientRemoval?.FieldGUID === field.FieldGUID}
                        style={{cursor: 'pointer',}}
                        onClick={() => dispatch(userSelectedFarmFieldWithNutrientRemoval(field))}>
                        {field.FieldId}
                      </CListGroupItem>
                    );
                  })
                }
              </CListGroup>
            </CCardBody>
          </CCard>
        </CContainer>
      </div>
      <div style={{flexDirection: 'column', display: 'flex',}}>
        <div
          style={{
            width: width - 300,
            height: height,
          }}>
          <Map
            mapId='NUTRIENT_REMOVAL_MAP'
            defaultCenter={{
              lng: -88.257311,
              lat: 40.112519,
            }} 
            defaultZoom={parseInt(process.env.REACT_APP_DEFAULT_MAP_ZOOM)}
            fullscreenControl={false}
            mapTypeControl={true}
            streetViewControl={false}
            mapTypeId='hybrid'
          >
            {
              fetchingFarmFieldsWithNutrientRemoval === true ? (
                <MapControl position={ControlPosition.CENTER}>
                  <MapLoadingSpinner loadingText='Fetching Farm Fields' />
                </MapControl>
              ) : null
            }
            {
              selectedFarmFieldWithNutrientRemoval !== null ? (
                <>
                  <NutrientRemovalMarker farmField={selectedFarmFieldWithNutrientRemoval} />
                </>
              ) : null
            }
            {
              selectedFarmFieldWithNutrientRemoval?.GoogleMapFieldPolygons.map((polygon, index) => (
                <MyFieldsAgvanceFieldBoundary farmFieldPolygon={polygon} key={index} fillColor='#FF5F00' />
              ))
            }
          </Map>
        </div>
      </div>
    </div>
  );
}

export default NutrientRemoval;
